(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-product-section]').forEach((section) => {
      const select = section.querySelector('[data-variant-select]');
      if (!select || select.dataset.bound === 'true') return;
      select.dataset.bound = 'true';
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        const price = section.querySelector('[data-product-price]');
        const button = section.querySelector('[data-add-button]');
        if (price) price.textContent = option.dataset.price || '';
        if (button) {
          button.disabled = option.dataset.available !== 'true';
          button.textContent = button.disabled ? button.dataset.soldLabel : button.dataset.addLabel;
        }
        if (!window.Shopify?.designMode) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', option.value);
          window.history.replaceState({}, '', url);
        }
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.site-header details[open]').forEach((details) => {
      details.removeAttribute('open');
      details.querySelector('summary')?.focus();
    });
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.site-header details[open]').forEach((details) => {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });
})();
